import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { AppErrorState } from '../../app/error-state.js';
import { AdministrationFrame } from '../../features/settings/components/administration-frame.js';
import { SettingsPage } from '../../features/settings/components/settings-page.js';
import { useSupportAccessPolicy, useSupportGrants } from '../../features/settings/grants/api.js';
import { GrantList } from '../../features/settings/grants/components/grant-list.js';
import { SupportAccessPolicyForm } from '../../features/settings/grants/components/support-access-policy-form.js';

export const Route = createFileRoute('/settings/grants')({ component: SupportGrantSettings });

/**
 * Support access, as this tenant controls it: the requests, the policy, and the way out.
 *
 * The page the owner answers from. Everything an operator can do inside this tenant started here
 * or was allowed by the policy on it, and the list is the record of both.
 */
function SupportGrantSettings() {
  const { t } = useTranslation();
  const grants = useSupportGrants();
  const policy = useSupportAccessPolicy();

  return (
    <AdministrationFrame>
      <SettingsPage title={t('grants.title')} description={t('grants.description')}>
        {policy.isError ? (
          <AppErrorState error={policy.error} resetErrorBoundary={() => void policy.refetch()} />
        ) : policy.isSuccess ? (
          <SupportAccessPolicyForm policy={policy.data} />
        ) : null}

        {grants.isError ? (
          <AppErrorState error={grants.error} resetErrorBoundary={() => void grants.refetch()} />
        ) : (
          <GrantList grants={grants.data?.items ?? []} loading={grants.isPending} />
        )}
      </SettingsPage>
    </AdministrationFrame>
  );
}
